import type { RootState } from 'store';
import { exportFileState } from 'util/file';
import { StorageUnitType } from 'store/storageunits/types';
import type { CurrentFile, StorageUnitUpdate } from 'store/storageunits/types';
import type { Thumbnails } from 'util/thumbnailGenerator';

type DesignerSaveState = {
  currentFile: Pick<CurrentFile, 'id' | 'name'>;
  unitState: RootState['unitConnGroup']['present']['unitState'];
  connectionState: RootState['unitConnGroup']['present']['connectionState'];
  settingsState: RootState['settingsState'];
  documentMetadata: RootState['documentMetadata'];
  fileState: RootState['fileState'];
  thumbnails?: Thumbnails | null;
};

export const buildDesignerStorageUnitUpdate = ({
  currentFile,
  unitState,
  connectionState,
  settingsState,
  documentMetadata,
  fileState,
  thumbnails,
}: DesignerSaveState): StorageUnitUpdate => {
  const fileName = currentFile.name;

  return {
    id: currentFile.id,
    type: StorageUnitType.File,
    name: fileName,
    fileData: exportFileState({
      unitState,
      connectionState,
      settingState: { ...settingsState, fileName },
      documentMetadata,
      fileState,
      clearApprovedStatus: true,
    }),
    thumbnail: thumbnails?.thumbnail,
    thumbnailDark: thumbnails?.thumbnailDark,
    flowsheetMetadata: documentMetadata.flowsheetMetadata,
  };
};
